// removed by extract-text-webpack-plugin
module.exports = {"layout":"_1LupgMYbAI9QD6Ydp0g5xh","safe":"_2WPhiL7Gtfw9QXDHDEPYdv"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/CenterLayout/styles.scss
// module id = 634
// module chunks = 11